export default {
  "+wet4N": "Error del código de verificación",
  "2QzYmY": "Cancelar",
  "32AbcK": "Seleccione empresa",
  "4R5GEq": "Inicio",
  "9Kfib+": "Error desconocido",
  "9UZxwP": "Por favor ingresa el código de verificación",
  "9cYMNA": "Información de la Empresa",
  "9ljNkr": "Reenviar",
  "9vpYSL": "Eliminar empresa",
  "EWMpn/": "Eliminar rol",
  FEb7U2: "Confirmar",
  "J3BW/8":
    "Por favor ingrese el código de verificación que recibió por correo electrónico",
  "QK/hAI": "Ver permisos",
  TqDOFU: "¡Por favor no envíe códigos de verificación con frecuencia!",
  XeiAal: "Eliminar",
  aiBGBs: "Eliminar con éxito",
  azDNha: "Enviado exitosamente",
  "e/6XZC": "¿No recibiste el código de verificación?",
  jNxbTC: "El código de verificación no puede estar vacío",
  l1fZNE: "No se pueden desmarcar todas las casillas",
  "2MYr1m": "iniciar sesión",
  "lzP/we": "Descarga",
  m0Qdyj: "Verificación fallida",
  nJCPaY:
    "El usuario no tiene una dirección de correo electrónico vinculada y no puede ser verificada",
  x79O39: "¿Estás seguro de eliminar?",
  xxETOY: "Configuración de permisos de datos de la empresa",
  yGWx2z: "Error de parámetro",
  Unvxiq: "Cambiar cuenta",
  ggvI6Z: "Seleccionar todo",
  lKbhpS:
    "Período de actualización en escala de grises del dispositivo (hora local)",
  ayUfs1: "La hora de finalización no puede ser anterior a la hora de inicio",
  "03eM6t": "200 artículos/página",
  "7/cUwn": "Período de tiempo actualizable del dispositivo (hora local)",
  SGDlQ6: "{total} elementos en total",
  "arp+TQ": "50 elementos/página",
  e8OyHO: "20 artículos/página",
  iyOrrD: "100 artículos/página",
  yXsHgv: "10 artículos/página",
  "+/R6RX": "Estado de la tarea",
  "+0SHNk": "Dirección MAC de Wi-Fi",
  "+4lD9e": "Nombre",
  "+74JfZ": "Ejemplo: Dispositivo_000001_Tienda Gaoqiao_Android",
  "+7V2pl": "común",
  "+CLSks":
    "2. El tipo de sistema de dispositivo al que se aplica esta regla de nomenclatura.",
  "+GQdfc": "ActualizarToken",
  "+L9lak": "Aplicar plantilla de alarma",
  "+TzicH": "almacenar",
  "+gbx50": "Condición de alarma",
  "+kHAfa": "Por favor complete los detalles de la tienda",
  "+m8vFq": "Detalles de la regla de nomenclatura",
  "/8GfsH": "cuatro",
  "/99v4N": "Todas las tiendas",
  "/CxA3j": "Agregar subtienda",
  "/Qlgz9": "Cargar un dispositivo Windows",
  "/SqqyP": "Ingrese el número de serie del dispositivo",
  "/cqdKk": "descargar",
  "/sI6h+": "gente",
  "0KH9Qi": "Tipo de sistema de dispositivo",
  "0VK6Tv": "Estado del negocio",
  "0YYUNG": "{num} etiquetas seleccionadas",
  "0iTEVO": "Ver token",
  "0uRy1k": "uno",
  "11uVJ/": "Recibir objeto",
  "19+woq": "Detalles de la tienda",
  "1M03Dq": "Plantilla de horario",
  "1PtjRr": "Nombre del dispositivo",
  "1SslIM": "Cerrar aplicación",
  "1X8SYs": "Latitud y longitud",
  "1sAivX": "Dirección MAC de Ethernet",
  "1sj5Sj":
    "Eliminar todas las plantillas de programación aplicadas a este dispositivo",
  "2/LdaO": "Almacenar información de configuración",
  "2JW1Pt":
    "Por favor elija si desea enviar correos electrónicos al mismo tiempo",
  "2nV3tA": "Ninguna tienda seleccionada",
  "2opnVU": "Durante la ejecución",
  "2qrsN7": "Por favor seleccione la dirección de la tienda",
  "2r/XUW":
    "Eliminar todas las plantillas de programación aplicadas por esta etiqueta",
  "3HzQUc": "Exportar JSON",
  "3QXG/d": "versión ora",
  "3XHWMy": "Jueves",
  "3aYG4L":
    "Elimine la plantilla de alarma aplicada actualmente al dispositivo y ya no monitoree ni envíe alarmas.",
  "3h+3Xm": "No abierto al público",
  "3jyOjJ": 'Si se debe modificar el dispositivo seleccionado a "Registrado"',
  "3qF993":
    "No puede transferir un dispositivo que no sea parte de su empresa actual.",
  "4/e9qs": "Por favor complete el nombre",
  "4Xdib8": "El período de tiempo no puede estar vacío",
  "4c3uw8": "Salir de la tienda",
  "4vWL+W": "Importar dispositivo",
  "4wi+/p": "plantilla",
  "5+oaTO": "estado de la última actualización de la imagen",
  "5Cm9U3": "Notificación de mensaje",
  "5Hy0Qx": "No se puede transferir a la misma tienda.",
  "5KtG4i": "buscar negocios",
  "5WKL9+": "Seleccionar estado de la tienda",
  "5jpkHg": "estado en línea",
  "5p8cBO": "Gestión de cuentas",
  "5ytYaf": "Agregar nueva plantilla de horario",
  "6+iYA0": "número de serie",
  "60Ixlm": "Nombre de la plantilla de alarma",
  "6eB+xj": "Por favor seleccione un usuario específico",
  "6pDRb2": "Por favor ingrese una contraseña válida",
  "7ip592": "1. Nombre de la regla de nomenclatura",
  "88CuCZ":
    "3. Establezca un método de denominación para los equipos registrados en esta tienda (rellene automáticamente el nombre del equipo)",
  "8PESa6": "Desactivar",
  "8huAxo": "Agregar nueva regla",
  "8u3CYe": "nombre de la regla de nomenclatura",
  "8usMqO": "Eliminar anuncio",
  "8zN+hZ": "Ejecutar aplicación",
  "9/Vb7e": "Cargar dispositivo",
  "919TK9": "Formatos soportados: xls, xlsx",
  "9AsSO/": "Elija si desea enviar mensajes de texto al mismo tiempo",
  "9UefLp": "Etiqueta",
  "9g6s9o": "Por favor complete el código de la tienda",
  "9iKk2b": "Número inicial",
  "9r00YD": "Gestión de anuncios",
  "9w+ho+": "cuenta",
  "9yRpjk": "Sábado",
  "A/eXwT": "Eliminar todas las plantillas de alarma aplicadas a esta etiqueta",
  A5kf1W: "Toda la lista de empresas",
  ANeFu6: "Verificar contraseña",
  Abqe2U: "Dirección de la tienda",
  Axagls: "Por favor seleccione la hora de finalización",
  AyWMlZ: "Agregar tarea programada",
  B57Wbu: "Ningún dispositivo seleccionado",
  BBpRbn: "Eliminar todas las plantillas de alarma aplicadas a esta tienda",
  BC74I9: "Mensaje rápido",
  BQcLxf: "bajar",
  BYbqwY: "Arrastre su archivo aquí o haga clic en Cargar",
  BwXapw:
    "Por favor controle el nombre de la categoría dentro de 500 caracteres",
  C6cGK1: "El nombre de la plantilla de programación no puede estar vacío",
  CLqPBU: "editar",
  CPTAAj: "Números naturales crecientes",
  D5HOUz: "Seleccionar estado",
  DADacD:
    "Eliminar todas las plantillas de programación aplicadas a esta tienda",
  DFyP1k: "Cerrar tienda",
  DxGUhN: "Seleccionar todos los dispositivos",
  E1GPl7: "dueño",
  EGvInA: "Lista de alarmas del dispositivo",
  EM8lAi:
    "Periodo de tiempo actualizable por equipo de la empresa (hora local)",
  "EO+Nlk": "El archivo se está cargando, no cierre el cuadro de diálogo.",
  EwM8Kj: "¿Estás seguro de que quieres mudarte?",
  Ey9rBq: "¿Estás seguro de que quieres eliminarlo?",
  F2LJDJ: "¿Estás seguro de que quieres eliminar?",
  F3ndvv: "Error al eliminar",
  FBH89G: "versión modificada",
  FNIJXx: "Por favor seleccione reproducir con desplazamiento",
  "FaJ/jI": "No se ha seleccionado ningún archivo para importar",
  FbCeo1: "valor de activación",
  FbsCUK: "Teléfono móvil",
  "Fr1I/b": "etiqueta",
  Ft60hS: "Equipos Nubis",
  G4XFn6: "Modelo de hardware",
  G4qgGm: "todos los usuarios",
  G5gg2V: "El título del anuncio es obligatorio.",
  G6i1QR: "Seleccionar dirección",
  G9APSK: "Editar reglas de nomenclatura",
  Gk0Mt5:
    "¿Está seguro de que desea restablecer ({name}) el dispositivo de alarma? Las reglas de alarma continuarán monitoreándose después del reinicio.",
  GnzEo7: "hora de la última actualización de la imagen",
  GujK99:
    "Si el contenido de la plantilla de alarma se actualiza más tarde, también se sincronizará con el dispositivo aplicado.",
  Gwj7xc: "Restaurar valor predeterminado",
  H5s58g: "24 horas",
  HN1dNJ: "Todas las cuentas",
  HOHQFs: "El nombre de la regla de nomenclatura no puede estar vacío",
  HRXYJB: "Todas las empresas",
  "HdxQ2/":
    "Archivos de configuración relacionados con la tienda y reglas de nomenclatura",
  "Hv/pfB": "Martes",
  I37xbU: "Por favor complete",
  ITbo35: "¡El nombre de la tienda no puede estar vacío!",
  IqkgWZ: "Palabras clave",
  "Iwt/8W": "anotación",
  "J0D5h+": "hora de inicio",
  J9jPRL: "Copiado exitosamente",
  JJl2M9: "Exportar",
  JLMIof: "Subir dispositivo Android",
  JRhVym: "El horario comercial no puede estar vacío.",
  JeJAmT: "Rebautizar",
  Jh62y5: "Todos los dispositivos",
  Jp7u8z: "torre",
  KJHvMA: "Gestión de tienda",
  KlWMzW: "Activado",
  Km733q: "Por favor seleccione una hora de inicio",
  Kwqd8h: "Persona de contacto",
  L24ioQ: "título",
  L80hmc: "El título del anuncio no debe exceder los 30 caracteres.",
  LNGTru: "Lista de errores de programación de dispositivos",
  LWSLHa: "Consejos amables",
  Lfia0v: "Configurar horario",
  "LuP+H0": "describir",
  LwhdsE: "Alternar selección múltiple",
  M404r0: "dos",
  MZ5Ei7:
    "El período de tiempo se superpone con el {num}ésimo período de tiempo",
  MmsEyp: "registro",
  MnTdIi: "Número de desencadenantes",
  N52KMq: "Dirección detallada",
  NGs9sO: "devolver",
  "NM/lRq": "Cancelar carga",
  NjB2tN: "¡Seleccione el estado del negocio!",
  OMcnk6: "Fabricante",
  OSqnZu: "Si se debe cambiar la versión del dispositivo seleccionado a",
  "OZGX3+": "Lista de anuncios",
  OaZpDP: "UUID",
  OcijhH: "Número de serie de la placa base",
  OsMncl: "No encendido",
  "P/eul9": "No",
  PVmkgT: "Por favor complete el nombre corto",
  PaMvre: "Lista de reglas de alarma",
  PnYplH: "equipo",
  PrIueu: "Abierto las 24 horas",
  "Py/5UG": "El nodo que se está operando ya no existe, opere nuevamente.",
  "Q+0CDu": "Agregar reglas de nomenclatura",
  "Q2/NzC": "{num} dispositivos seleccionados",
  QHc9Qg: "Contenido del anuncio",
  QHhMxE: "Seleccionar rol",
  QLYuf8: "Todas las empresas",
  QV3pnn: "estado",
  QpOtgZ: "Nombre de la tienda",
  Qpcx6F: "El contenido del anuncio es obligatorio.",
  Qpi3DY: "día",
  "QsAe0/": "Error al guardar",
  QwHI8Q: "Resultados de la consulta:",
  R2D5Dv: "tiempo de creación",
  RCjVsb: "ID del dispositivo",
  RNaGVr: "Lista de fallas de tareas",
  RQyKsa: "Anuncio de plataforma",
  RWBRyt: "El mapa de distribución de equipos está en construcción.",
  RndUeh: "Tiempo estimado de ejecución",
  RyXQqJ: "tiempo de carga",
  S1QSWC: "Importar a la subtienda",
  S57QRB: "Filtrar por",
  SbZhau:
    "La tarea de arranque necesita especificar un dispositivo de arranque.",
  SkK50H: "Por favor agregue una tarea programada",
  SwMBFl: "Aplicar plantilla de horario",
  T3CtvK: "El nombre de la categoría no puede estar vacío",
  TDSTTj: "Seleccione una plantilla de horario",
  TDuPUp: "Motivado",
  TLZPhr: "Lunes",
  TYAJpp: "{num} tiendas seleccionadas",
  UA7mv6: "Hora de la última actualización de Ora",
  UBbWUL: "Ninguna plantilla seleccionada",
  UZ49sl: "Número de teléfono del responsable",
  UtE0dS: "funcionar",
  "Uu/nFu":
    "Eliminar todas las plantillas de alarma aplicadas a este dispositivo",
  V0RiZp: "Operación exitosa",
  Vd3wZV: "en general",
  Ve9Ksw: "Mover tienda",
  ViVQNi: "Role",
  VqEr9u: "Número de tiendas a las que aplicar",
  Vx4M25: "código de tienda",
  "W/wIZ8": "persona responsable",
  WYHxWn: "tres",
  WYtW9Y: "Por favor seleccione una versión",
  WdyIyo: "tiempo de operación",
  WtPk7v: "Enviar SMS simultáneamente",
  WxPZOH: "Ejecutar {num} veces",
  WypzMq: "Tareas programadas",
  Wzv7kF: "Por favor seleccione una tienda",
  X2PYza: "Detalles del dispositivo",
  "XKj/en": "número de serie del BIOS",
  "XLdI1+": "Potencia de Wi-Fi",
  XMBOec: "Quitar etiqueta",
  XPFi6q: "banda",
  XmRKnc: "Observación",
  YYGRyG: "Por favor cargue archivos adjuntos",
  YeF1dY: "huso horario",
  YpXN8m: "Hora del último disparo",
  YwEzx2: "Marque los campos que deben mostrarse",
  ZGYHyC: "La hora de inicio no puede estar vacía",
  ZQ91U9: "Hogar",
  ZUPzqr: "encender",
  ZdO12B: "Aplicar a la tienda",
  "Zvt+2g": "almacenamiento",
  aBleoN: "Seleccionar plantilla de alarma",
  aGxRt2: "contenido",
  "aN+DgN": "tiempo de activación",
  akvGrq: "Configurar reglas",
  askOz5: "Buscar dirección",
  "b+Dz+s": "Lista de todas las tiendas",
  b5l2vN: "ahorrar",
  bBz42a: "estado de actualización",
  "bE+h3K": "Estado del dispositivo",
  bFBjSK: "cinco",
  bOKDVF: "Alternar radio",
  biXcnk: "Correo electrónico del responsable",
  bqbDVw: "Consulta",
  bzfrYI: "Configuración de anuncios",
  cDZ00w: "Controlar",
  "cZ9/ZC": "¿Eliminar [{nombre}]?",
  cawvIS: "Última actualización",
  cgIBtg: "Seleccionar nivel superior",
  cr1ymH: "Por favor seleccione la hora de envío",
  "d7i/AT": "capa superior",
  dEXfrL: "Intervalo de estado de salud del dispositivo",
  dGBGbt: "todo",
  drCsUI: "compañía",
  eAgY2G: "Ampliar filiales",
  eCCa0L: "Tipo de tarea",
  "eP/37G": "Hora de registro",
  eeCxuz: "tipo de sistema operativo",
  evJP5c: "reglas de nomenclatura",
  f7Dpbl:
    "Descargue la plantilla y mejore el contenido según las indicaciones de la plantilla.",
  "fc12+X": "Viernes",
  fz2pkM: "El nodo ha sido eliminado.",
  gU4eZD: "Gestión de alarmas",
  gmUXEi: "Valor característico del equipo",
  gnNjS5: "Nombre del dispositivo personal",
  gpg5DN: "Ver anuncio",
  gplM71: "a diario",
  "gyh+d1": "red cableada",
  "h/j3a5": "Número de teléfono de contacto",
  h7w4pz: "Aún no hay datos",
  "hD7/Lu": "espectáculo",
  "hDx3/S": "Correo",
  hEI4G8: "Nuevo anuncio",
  hYN7oM: "esconder",
  hkJXyi: "Configurar tareas programadas",
  i5MLJc: "Última actualización: {lastUpdate}",
  "i6kDf/":
    "Si el dispositivo seleccionado contiene {num} versiones gratuitas de Nubis, los comandos del dispositivo no estarán disponibles.",
  iKomBu: "Aún no hay clasificación",
  iN7Lps: "modo ciclo",
  ich0wH: "DispositivoSN",
  ifGp4v: "2FA",
  "j/YGZ0": "mapa",
  j3QWSE:
    "El número inicial para el incremento de números naturales solo puede ser un número entero positivo",
  j6m8Si: "Correo electrónico de contacto",
  jAAXdQ: "Tienda de equipos",
  jT6zKT: "Número de dispositivos",
  "jhfb/7": "Guardado exitosamente",
  js3tZs: "Nombre de la plantilla de programación",
  k7dy8j: "Archivos de configuración asociados",
  k9dozc: "tiempo de ejecución",
  kG2Etz: "en línea",
  khyRcw: "Por favor seleccione el archivo Excel",
  "kr+7Iy": "Buscar tienda",
  l36W55: "jugar con desplazamiento",
  lK6HPZ: "Por favor seleccione un estado de tienda",
  lVgYx7: "Suspendido",
  lllhRf: "La hora de finalización no puede estar vacía",
  loTFGc: "Sin nombre",
  m1h20o:
    "Si el contenido de la plantilla de programación se actualiza más tarde, también se sincronizará con el dispositivo aplicado.",
  mFIXSq: "Número de serie del dispositivo",
  mKKd1R: "Por favor seleccione destinatarios",
  "mYa6W/": "Texto personalizado",
  ma6S6y: "Pantalla personalizada",
  mn0ceu: "Hay reglas de configuración duplicadas, ajústelas.",
  "mpeFt+": "Reglas de alarma",
  nGubXb: "Detalles de la plantilla de programación",
  nUSeQB: "Ninguna cuenta seleccionada",
  nzsNwZ: "Estado de salud del dispositivo",
  "o+O5d1": "Por favor seleccione tarea",
  o5OLcm: "Abreviatura de la tienda",
  o8tJYm: "comando del dispositivo",
  o9lryN: "Domingo",
  "oFt+cN": "Prueba de velocidad de red",
  oW4Uka: "asignar",
  obfTaf: "Configuración de la tienda",
  ojz0Ke: "Ver más >",
  oru5FY: "Editar plantilla de horario",
  "p/3Nn5": "red móvil",
  pBPyFt: "versión nubis",
  pK94Zd: "Importar a la tienda",
  "pV2t/S": "Información básica",
  pXEyon: "Tipo de dispositivo",
  peNVzr: "cada {num} semanas",
  peUIwk: "Crear anuncio",
  pfGGi0:
    "Elimine la plantilla de programación aplicada actualmente al dispositivo y no la ejecute más.",
  pielKO: "Dispositivo de arranque",
  q6qKtH: "Condiciones de consulta:",
  q9PHLT: "Aún no hay anuncio",
  q9YGIf: "Negocio",
  qDba8m: "Estado del dispositivo sin conexión",
  qUKj7E: "Copiar",
  qUiH5y: "Las reglas de configuración no pueden estar vacías",
  "qqwM/t": "Archivo de configuración",
  qyh9hz: "Horario comercial",
  "r0/TUu": "Seguro",
  "r2dEd/": "reiniciar",
  rAKRwm: "Seleccione la versión del dispositivo",
  rDRAr0: "Versión del sistema operativo",
  s1l1Jq: "Gestión de tiendas y cuentas.",
  s7NSze:
    "Por favor ingrese la contraseña de su cuenta antes de confirmar la operación.",
  s9U9qn: "Establecer alarma",
  sGYTej: "descansar",
  sOIerB: "No activado",
  sVsXUO: "Miércoles",
  sZSyGZ: "permitir",
  srEpKw: "Subiendo",
  srpWCM:
    "Marque los campos que deben mostrarse y arrástrelos para ordenarlos.",
  t5gffJ: "Información del equipo",
  tugHWJ: "Volver a la lista de anuncios",
  u3dVQz: "semanalmente",
  ubuOXs: "Registrado",
  ujBeLh: "Notificación pública del sistema de mantenimiento.",
  "uoZwj+": "Creador",
  uuRzdk: "pertenecer a la tienda",
  v04auv: "tiempo final",
  vD5wnY:
    "Marque la tienda a la que desea pertenecer, lo que significa que tiene el permiso de la tienda.",
  vDCwZ9: "Subir archivos",
  vr5TVT: "Por favor ingresa",
  wOHHSJ: "subir",
  wQAiLI: "Restablecer recordatorio",
  wYygRu: "remitente",
  "wrU/Kc": "cada {num} días",
  x34QXR: "La hora de finalización no puede ser anterior a la hora de inicio.",
  xI0mPJ: "Ya encendido",
  xISm1t: "activación",
  xUjLTE: "buscar",
  xXdMar: "Especificar usuario",
  xuf2rG: "Todas las tiendas",
  xx40g7: "Título del anuncio",
  "y+WxsP": "Aviso editorial",
  yKFvYY: "Enviar correos electrónicos simultáneamente",
  yOMNOj: "Sí",
  yReEcE: "Seleccionar etiqueta",
  yb3AuG: "Desconectado",
  ybGQQ3: "Sin resultados relevantes",
  yc6ZUL: "Ora último estado actualizado",
  ydktLD: "delimitador",
  yeCGlM: "seis",
  yfhtRM: "apéndice",
  ygAHaf: "enviar hora",
  yy7EDI: "subir",
  zftpop: "Seleccionar usuario",
  znuEgQ: "Agregar horario comercial",
  zok1hp: "ranura C",
  zvaxmN: "Gestión de horarios",
  zyMKgy: "Seleccionar tienda",
  o5QBKU: "compañía actualizada con éxito",
  "1yM7WW": "¿Eliminar el dispositivo seleccionado?",
  DqB8kg: "Quitar dispositivo",
  QH21BX: "Registro por lotes de dispositivos",
  TlDh4N: "Eliminar dispositivos en lotes",
  UcumBq: "Notificación de alarma",
  X9zJwr: "Asignar dispositivos en lotes",
  lkP6UV: "Actualizar dispositivo",
  wLyMu9: "Mejora el contenido según las indicaciones de la plantilla",
  FQM81K: "¿ cambiar el Estado de la tienda elegida a",
  WqfGVu: "Limitado a 30 palabras",
  hV5chR: "Seleccione si desea que aparezca una ventana emergente",
  vD7UHb: "Ventana emergente",
  "0Drg5o": "Acepto los términos anteriores",
  "7pY6K/": "Términos y Condiciones",
  CNkomH: "Términos editoriales",
  CoaQps: "Gestión de términos",
  "HHA/d7": "Lista de términos",
  UH1kCc: "Agregar",
  "VzqtN+": "Se requieren términos y condiciones",
  hOtsIx: "Nuevo artículo",
  ilUpPP: "Devolver lista de términos",
  "j+y4w+": "El título del término es obligatorio",
  j4CmNU: "Ver términos",
  jJg298: "Título del artículo",
  t4lrWD: "El título del artículo no debe exceder los 30 caracteres",
  z7A1Fc: "Crear términos",
  "OY+bYK": "Confirmar, no volver a mostrarlo",
  "+d1f6p": "Subir dispositivo Linux",
  UrM0bR: "Información de autenticación",
  "+uAolt": "Ejemplo: Permitir a los usuarios personalizar fácilmente los títulos, iconos y textos del sitio web para una experiencia web personalizada.",
  "0UAhKu": "Ejemplo: https://nubiscloud.freshdesk.com/support/home",
  "0h3ZUE": "Subir al Centro de Cuentas",
  "0lEh3g": "Subir al Espacio Nubis",
  "0xMj0V": "Ejemplo: Proporcionar una nueva versión o actualizar la imagen del dispositivo",
  "3DMdxJ": "Editar pestaña del Centro de Dispositivos",
  "4ImW13": "Ejemplo: Administración de la Tienda",
  "52LsQF": "Ejemplo: Centro de Cuentas",
  "5BTra1": "Ejemplo: Plataforma",
  "61gplm": "Subir texto",
  "6sZvzw": "Reemplazar palabras clave del Centro de Dispositivos",
  "7bKyxU": "Las imágenes subidas se almacenarán en el explorador de archivos de Nubis Drive. La corrupción o eliminación de archivos provocará un error al cargar las imágenes",
  "7q8OJE": "Editar plataforma",
  "8TfVSD": "Editar pestaña de plataforma",
  "8pToBN": "Ejemplo: Cloud",
  "9/8z30": "Permitir a los usuarios personalizar fácilmente el título, el icono y el texto del sitio web para una experiencia web personalizada",
  "9C+wuW": "Ejemplo: Administración de dispositivos",
  "D1cAYC": "Ejemplo: Centro de dispositivos",
  "FKBH20": "Ejemplo: Espacio Nubis",
  "G+eQYn": "Ejemplo: Administración de tiendas y cuentas",
  "G2LkOf": "Subir a la administración de anuncios",
  "I9uxGU": "Ejemplo: Servicio global, Crea tu imaginación, Ofrece una experiencia inteligente",
  "K1Xqdl": "Ejemplo: Administración de permisos",
  "LTVlAP": "Subir al Centro de actualizaciones",
  "Q1/SUP": "Ejemplo: Aviso público del sistema de mantenimiento",
  "QAN35o": "Ejemplo: Administración de dispositivos, Monitoreo, Control remoto, etc.",
  "R8nCNR": "Subir a la administración de dispositivos",
  "TVuUjT": "Ora",
  "U08bUN": "Subir al Centro de Dispositivos",
  "Wu2nnZ": "Introducción a la Plataforma",
  "ZP1/uy": "Ejemplo: Administración de Permisos de Roles de la Plataforma Nubis",
  "ayjmy+": "Ejemplo: Administración de Dispositivos y Grupos en Todo el Mundo",
  "bhXvJB": "Subir a la Administración de Permisos",
  "cAIDk5": "Centro de Soporte",
  "d3b8dv": "Subir a la Administración Personalizada",
  "dFHONh": "Nubis",
  "dWy8l5": "Ejemplo: Ora",
  "fZJ9SZ": "Ejemplo: Administración de Cuentas para Socios y Clientes",
  "jAmQmn": "Ejemplo: Centro de Desarrollo",
  "kwx95y": "Ejemplo: Administración Personalizada",
  "ov96O9": "Administración Personalizada",
  "rM4ciX": "Ejemplo: Anuncio Administración",
  "uDYj3x": "Centro de sitios web",
  "uRrPru": "Subir archivos de administración de la tienda",
  "vdUVb9": "Ejemplo: Centro de actualizaciones",
  "xrKftB": "Subir iconos",
  "2IaM+V": "Centro de actualizaciones",
  "EoXhnk": "Centro de dispositivos",
  "JeSd9K": "Otro",
  "wzIKok": "Hereda la configuración personalizada de la empresa de nivel superior",
  "BQDKvZ": "Ejemplo: Agente",
  "EO9pTF": "Ejemplo: Nube",
  "/NrLZv": "Cantidad de licencias",
  "1Dklb3": "Fecha de entrada en vigor automática",
  "1dyq46": "CMS",
  "1t0NXU": "Fecha de pago",
  "2DbIoa": "Detalles del pedido",
  "2hUF5M": "Seleccione al menos 1 licencia",
  "2qqw4C": "Vendedor",
  "3Y6eOz": "Vencida",
  "5FboZ/": "Tipo",
  "6bBRd8": "Correo electrónico del cliente",
  "6jMfox": "Registros de pedidos recibidos",
  "D0cpCO": "Cantidad de licencias",
  "EBMdAL": "Creada correctamente",
  "FDRhoz": "Enviada",
  "G0UYbD": "Seleccionar licencias",
  "GCrD1e": "Días restantes",
  "JeSd9K": "Otro", "JmnNA0": "Campo opcional",
  "LG70v2": "Enviar registro de pedido",
  "NZQWZL": "Formal",
  "PjtWQX": "{num} Licencias seleccionadas",
  "Plhuph": "Buscar número de pedido, número de ERP",
  "Rrwy85": "Creador",
  "TX6jKq": "Destinatario",
  "U+pKlD": "¿Eliminar número de pedido: {name}?",
  "Xvn+2E": "Contacto del cliente",
  "YII2+w": "Fecha de vencimiento",
  "YJbxtM": "Empresa recibida",
  "ZIJmYm": "Gestión de pedidos",
  "ZTs8/J": "Crear licencias",
  "a7AYs5": "Período de validez (días)",
  "eM8o1Y": "Número de pedido",
  "eUSpdN": "Ver más",
  "er7lkB": "Importe",
  "fyjje7": "Licencia Clave",
  "gqvOsW": "Persona de contacto del cliente", "iTiIWl": "No se encontraron datos coincidentes",
  "k1xuGk": "Buscar número de pedido",
  "kPb1Wj": "N.º de ERP",
  "lfUbAE": "Activo",
  "mPsm6o": "Pruebas",
  "ouraCD": "Administración de dispositivos",
  "pUL1dA": "Eliminar pedido",
  "pecEGk": "Cancelar",
  "sTreBL": "Fecha de entrada en vigor",
  "sbThvA": "Empresa de envío",
  "svGx//": "Introduzca un número válido",
  "tMGiGt": "Tipo de licencia",
  "tsV2n0": "Crear pedido",
  "twizE+": "Correo electrónico del vendedor",
  "u6rHwS": "Fecha de generación del pedido",
  "vePxOp": "Normal", "wNYTXq": "Sin usar",
  "wawZXM": "Estado de la licencia",
  "xVTk70": "Cargando",
  "xxFsds": "Campos obligatorios",
  "0axARa": "Fecha de vencimiento",
  "0tqhdw": "Los gerentes y niveles superiores recibirán correos electrónicos de [{x}] empresas, con un total de [{y}] empresas.",
  "4DfIa5": "El tipo de licencia seleccionado no debe ser una versión beta.",
  "4kc3eS": "El primer día de cada mes, el sistema enviará un correo electrónico con el estado de las licencias o dispositivos que requieren notificación. El correo electrónico contendrá la siguiente información.",
  "7FTqlN": "No hay licencias coincidentes.",
  "AfMAI0": "El dispositivo con una licencia recibirá automáticamente una nueva licencia cuando caduque la actual.",
  "FQjcoc": "Reglas de automatización de licencias.",
  "GDWKlf": "Número de serie del dispositivo emparejado.",
  "Iqlkbs": "El estado de la licencia seleccionada debe ser sin usar.",
  "K5iYC8": "Licencias sin usar que alcanzarán su fecha de activación automática en los próximos 100 días.",
  "NBz0wZ": "Licencias actualmente activas, pero no asignadas a ningún dispositivo.",
  "URkpah": "Licencias vencidas.",
  "UjxKxu": "Terminado",
  "VaAWfW": "Las licencias con fechas de vencimiento automáticas más cercanas tienen mayor prioridad",
  "Wp2PXY": "Configuración de notificaciones",
  "X2YceA": "Licencias sin usar",
  "ZLqStU": "Los dispositivos preimportados recibirán licencias automáticamente al registrarse",
  "daUauj": "Clave de licencia, número de pedido, número de serie del dispositivo emparejado",
  "eFFkgE": "Resumen del inventario de licencias",
  "eHMGvf": "Seleccione una licencia",
  "eR85km": "Dispositivo con una licencia autorizada que vence en los próximos 100 días. Si la licencia vence y no se proporciona una licencia de reemplazo, el dispositivo pasará a estado reservado",
  "fTfy0b": "El sistema aplicará automáticamente las licencias según las reglas de automatización de licencias",
  "ftSBnR": "Licencia emparejada",
  "lLC16+": "Gestión de licencias",
  "lQGDqR": "Dispositivo ya reservado o suspendido",
  "lTtEaU": "Reservado", "t0EXqz": "Licencias vigentes",
  "vPHZLC": "Incluye subsidiarias",
  "FQQECq": "Obligatorio",
  "ekxzlF": "Nombre"
};
